import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import api from "../../utils/api";

function E_View({ payid: propPayid }) {
  const [payslip, setPayslip] = useState([]);
  const { payid: paramPayid } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL;
  
  // Use prop payid if provided, otherwise use URL parameter
  const payid = propPayid || paramPayid;

  useEffect(() => {
    if (!payid) {
      console.error("No payid provided");
      return;
    }
    
    api
      .get(`/payslip/${payid}`)
      .then((response) => {
        setPayslip(response.data);
        console.log("Payslip data:", response.data);
      })
      .catch((error) => {
        console.error("Error fetching payslip data:", error);
      });
  }, [payid]);

  const handleDownload = async () => {
    try {
      const response = await api.get(`/payslip/download/${payid}`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${payslip.employeeId}_payslip_${payslip.salaryPeriod}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };

  return (
    <div className="space-y-4 p-3">
      {/* Earnings & Deductions Table */}
      <div className="overflow-x-auto">
            <table className="w-full border-collapse min-w-[600px]">
              <thead className="bg-slate-100">
                <tr>
                  <th className="border border-slate-300 p-2 text-xs sm:text-sm font-semibold">Earnings</th>
                  <th className="border border-slate-300 p-2 text-xs sm:text-sm font-semibold">Gross (Rs.)</th>
                  <th className="border border-slate-300 p-2 text-xs sm:text-sm font-semibold">Earned (Rs.)</th>
                  <th className="border border-slate-300 p-2 text-xs sm:text-sm font-semibold">Deductions</th>
                  <th className="border border-slate-300 p-2 text-xs sm:text-sm font-semibold">Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Basic</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grBasic != null ? `${payslip.grBasic}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.basic != null ? `${payslip.basic}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Professional Tax (PT)</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.pt || '-'}</td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">HRA</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grHra != null ? `${payslip.grHra}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.hra != null ? `${payslip.hra}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Income Tax (TDS)</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.tds != null ? `${payslip.tds}` : '-'}</td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Conveyance Allowance</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grTransportAllowance != null ? `${payslip.grTransportAllowance}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.transportAllowance != null ? `${payslip.transportAllowance}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Er PF Contribution</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grEmployeePf != null ? `${payslip.grEmployeePf}` : '-'}</td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Medical/Food Allowance</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grMedicalAllowance != null ? `${payslip.grMedicalAllowance}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.medicalAllowance != null ? `${payslip.medicalAllowance}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Ee PF Contribution</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grEmployeePf || '-'}</td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Er PF Contribution</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grEmployeePf != null ? `${payslip.grEmployeePf}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.employerPf != null ? `${payslip.employerPf}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Other Deductions</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.otherDeductions != null ? `${payslip.otherDeductions}` : '-'}</td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Ee PF Contribution</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grEmployeePf != null ? `${payslip.grEmployeePf}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.employerPf != null ? `${payslip.employerPf}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right"></td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Special allowance</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grSpecialAllowance != null ? `${payslip.grSpecialAllowance}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.specialAllowance != null ? `${payslip.specialAllowance}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Arrears</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.arrears != null ? `${payslip.arrears}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.arrears != null ? `${payslip.arrears}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Incentive/Bonus</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.bonus != null ? `${payslip.bonus}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.bonus != null ? `${payslip.bonus}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                </tr>
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Other Perquisites</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.otherPerquistes != null ? `${payslip.otherPerquistes}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.otherPerquistes != null ? `${payslip.otherPerquistes}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm"></td>
                </tr>
              </tbody>
              <tfoot className="bg-slate-100 font-semibold">
                <tr>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Total</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.gross != null ? `${payslip.gross}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.grossSalary != null ? `${payslip.grossSalary}` : '-'}</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm">Total</td>
                  <td className="border border-slate-300 p-2 text-xs sm:text-sm text-right">{payslip.totalDeductions != null ? `${payslip.totalDeductions}` : '-'}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Net Pay Info */}
          <div className="bg-slate-50 p-3 rounded">
            <div className="flex justify-between items-center gap-3 bg-white p-2 rounded border border-slate-300">
              <span className="font-semibold text-slate-700 text-xs sm:text-sm">Net Payment</span>
              <span className="font-bold text-sm sm:text-base">₹{payslip.netPayable}</span>
            </div>
          </div>
        </div>
     
   
  );
}

export default E_View;